export default "__VITE_ASSET__CYT7U2ZA__"